module.exports = __webpack_public_path__ + "r-v3/img/select_on.904d91bc.svg";